import { render, staticRenderFns } from "./PrkAssessmentMethods.vue?vue&type=template&id=52c81c6d&scoped=true&"
import script from "./PrkAssessmentMethods.vue?vue&type=script&lang=js&"
export * from "./PrkAssessmentMethods.vue?vue&type=script&lang=js&"
import style0 from "./PrkAssessmentMethods.vue?vue&type=style&index=0&id=52c81c6d&scoped=true&lang=scss&"
import style1 from "./PrkAssessmentMethods.vue?vue&type=style&index=1&id=52c81c6d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c81c6d",
  null
  
)

export default component.exports